const getAttributeObserver = (attribute, handler) => {
    /**
     * Handle attribute changes and childList changes from the observer
     * @param {MutationRecord[]} mutationList
     */
    const observerHandler = (mutationList) => {
        mutationList.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === attribute) {
                handler(mutation.target);
            }
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE &&
                        node.hasAttribute(attribute)) {
                        handler(node);
                    }
                });
            }
        });
    };
    // Initialize a mutation observer for patching accessibility features
    return new MutationObserver(observerHandler);
};

export { getAttributeObserver as g };
